import { Checkbox } from "@mui/material";
import PropTypes from "prop-types";
import { Fragment, useEffect, useState } from "react";
import {
  useExpanded,
  useFilters,
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import { Table } from "reactstrap";
import { DefaultColumnFilter } from "./filters";
import Helpers from "../../helpers/helpers";

// Define a default UI for filtering

const TableContainer = ({
  columns,
  data,
  customPageSize,
  className,
  onTableRowClick = false, checkedAll, setCheckedAll, module,
  sort, setSorted, sort_by, setSortBy, noHeader, headerBackground, headerTitleColor
}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      defaultColumn: { Filter: DefaultColumnFilter },
      initialState: {
        pageIndex: 0,
        pageSize: customPageSize,
        // sortBy: [
        //   {
        //     desc: true,
        //   },
        // ],
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination
  );

  const [pageNo, setPage] = useState(1)
  const [id, setID] = useState("")

  // const generateSortingIndicator = column => {
  //   return (
  //     <>
  //       {
  //         column.isSorted ?
  //           (column.isSortedDesc ? <i className="ri-sort-desc p-2"></i> : <i className="ri-sort-asc p-2"></i>) : <i className="ri-arrow-up-down-line p-2"></i>
  //       }
  //     </>
  //   )
  // };
  useEffect(() => {
    if (customPageSize && (pageSize !== customPageSize)) {
      setPageSize(customPageSize)
    }
  }, [customPageSize])

  const generateSortingIndicator = column => {
    if (sort === "asc") {
      return <i className="ri-arrow-up-long-fill me-2"></i>
    } else if (sort === "desc")
      return <i className="ri-arrow-down-long-line me-2"></i>
  };

  const handleSort = (columnID, idx) => {
    setSortBy && setSortBy(columnID?.columnID)
    setID(idx)
    sort === "asc" ? setSorted("desc") : setSorted("asc")
  }

  return (
    <Fragment>
      <div className="table-responsive react-table mb-2" style={{ backgroundColor: 'white' }}>
        <Table hover {...getTableProps()} className={className} responsive size="sm">
          {!noHeader &&
            <thead className="table-light table-nowrap ">
              {headerGroups.map((headerGroup, idx) => (
                <tr key={idx} style={{ position: 'relative', borderBottom: "1px solid #E2E2E2" }}>
                  {headerGroup.headers.map((column, idx) => (
                    <th
                      key={idx}
                      style={
                        column?.position === 'sticky' ? { minWidth: column?.minWidth || 0, position: 'sticky', right: 0, zIndex: 2, backgroundColor: headerBackground ? headerBackground : '#FFFFFF', padding: 10, } :
                          { minWidth: column?.minWidth || 0, backgroundColor: headerBackground ? headerBackground : '#FFFFFF', padding: 10, textAlign: 'center'}
                      }
                    >
                      {
                        column?.render("Header") === "#" ?
                          <Checkbox checked={Boolean(checkedAll)}
                            checkedIcon={Helpers.checkIcon()}
                            icon={<div style={{ width: 18, height: 18, borderRadius: 3, border: '2px solid #1D1B1B' }}></div>}
                            sx={{
                              // paddingBlock: 0,
                              borderRadius: 6,
                              color: '#1D1B1B',
                              '&.Mui-checked': {
                                color: "#1D1B1B",
                              },
                              '& .MuiSvgIcon-root': {
                                fontSize: 18,
                                fontWeight: 600
                              },
                            }} onChange={(event) => setCheckedAll(!checkedAll)} />
                          :
                          <div className="table-header" style={{ color: headerTitleColor ? headerTitleColor : '#1D1B1B'}} onClick={(e) => columns[idx]?.columnID ? handleSort(columns[idx], idx) : ""}>
                            {column.render("Header")}
                            <>{columns[idx]?.columnID ? id === idx ? generateSortingIndicator(column) : <i className="ri-expand-up-down-fill me-2"></i> : ""}</>
                            {columns[idx]?.headerIcon && columns[idx]?.headerIcon}
                          </div>
                      }
                      {/* <Filter column={column} /> */}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>}
          {
            data?.length > 0 &&
            <tbody {...getTableBodyProps()}>

              {page.map((row, idx) => {
                prepareRow(row);
                return (
                  <tr key={idx}
                    style={{
                      backgroundColor:
                        module === 'location_exist' ? row?.original?.is_conflicted === '1' ? '#00C49A1A' : '#B222221A' : '#FFFFFF',
                      borderColor: "#E2E2E2",
                      borderLeft: module === 'location_exist' ? row?.original?.is_conflicted === '1' ? '2px solid #00C49A' : '2px solid #B22222' : ''
                    }}>
                    {row.cells.map((cell, cellIdx) => (
                      <td key={cellIdx} className="align-content-center" onClick={(e) => {
                        if (onTableRowClick) {
                          e.stopPropagation();
                          // onTableRowClick(idx);
                          onTableRowClick(row.original)
                        }
                      }}
                        style={
                          cell.column.Header === 'Actions'
                            ? { color: '#454545', position: 'sticky', right: 0, zIndex: 2, backgroundColor: '#fffefe', cursor: "default", padding: 10, paddingLeft: 30 }
                            : { color: '#454545', cursor: onTableRowClick ? "pointer" : "default", padding: 10, paddingLeft: cell.column.Header === '#' ? 10 : 30 }
                        }
                      >
                        {cell.render("Cell")}
                      </td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          }
        </Table>
        {

          data?.length <= 0 &&
          <>
            {/* <div className="d-flex justify-content-center w-100 pb-2" key={'no record-1'}>
              <img src={no_data_image} alt="empty-data" style={{ height: 120, width: 120 }} />
            </div> */}
            <div className="d-flex justify-content-center align-items-center w-100 pb-2" key={'no record-2'} style={{ marginBottom: 10, color: '#999999', minHeight: 200 }}>
              Nothing here yet
            </div>
          </>
        }
      </div>

    </Fragment>
  );
};

TableContainer.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};

export default TableContainer;
